import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Table, { TableBody, TableCell, TableRow } from "material-ui/Table";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import Wrapper from "../../../common/Wrapper";
import Header from "../../../common/Header";
import Loader from "../../../Parts/Loader";
import ArrowLeft from "../../../Icons/ArrowLeft";
import NotificationBar from "../../../Parts/NotificationBar.jsx";
import { SalesforceJobState } from "../../../../constants/ComponentTypes";
import * as moment from "moment";

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  overview: {
    background: "#F4F6F9",
    flex: 1,
    width: "80%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  body: {
    width: "100%",
    margin: "10px 0px 90px 0px",
  },

  progressbar: {
    marginTop: "22px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  returnBtn: {
    padding: "8px 15px",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
  },

  heading: {
    width: "100%",
    marginTop: "14px",
  },

  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "12px",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  section: {
    paddingBottom: "50px",
    width: "100%",
  },

  sectionType: {
    fontWeight: "bold",
    marginBottom: "2px",
    color: "#71737B",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "40px",
  },

  desc: {
    marginTop: "5px",
    color: "#181819",
  },

  table: {
    width: "100%",
  },

  firstCol: {
    width: "30%",
    fontWeight: "bold",
    fontSize: "15px",
    padding: "30px 10px",
  },

  secondCol: {
    width: "70%",
    fontSize: "15px",
    padding: "30px 10px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "underline",
  },
});

class SalesforceImportHistoryDetail extends React.Component {
  state = {
    showNotification: false,
    message: "",
    messageType: "success",
  };

  componentDidMount() {
    this.props.getUserInfo();
    this.props.getSalesforceImportHistoriesById(this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.successMessage && nextProps.successMessage !== "") {
      this.displayNotification(nextProps.successMessage, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== "") {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== "") {
      this.displayNotification(nextProps.shortMessage, "green");
    }
  }

  /*** toggle funcions ***/
  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  displayJobState = (state) => {
    let text = "-";
    let jobState = Object.values(SalesforceJobState).find(
      (item) => item.value === state
    );

    if (jobState) {
      text = jobState.text;
    }
    return text;
  };

  calcDuration = (start, finish) => {
    if (!start || !finish) {
      return "-";
    }

    let diff = moment(finish).diff(moment(start));
    return moment.utc(diff).format("HH:mm:ss");
  };

  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          width: "98%",
          left: "1%",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : "100%",
          }}
        ></NotificationBar>
      </div>
    );
  };

  renderRow = (item, key) => (
    <TableRow key={key}>
      <TableCell className={this.props.classes.firstCol}>
        {item.field}
      </TableCell>
      <TableCell className={this.props.classes.secondCol}>
        {(() => {
          if (item && item.link) {
            return (
              <a
                className={this.props.classes.link}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.value}
              </a>
            );
          } else {
            return item.value;
          }
        })()}
      </TableCell>
    </TableRow>
  );

  renderRows = () => {
    const { importHistory } = this.props;

    if (importHistory !== null) {
      let detail = importHistory.detail
        ? JSON.parse(importHistory.detail)
        : null;

      let table = [
        { field: "ジョブID", value: importHistory.id },
        { field: "オブジェクト", value: importHistory.sobject_name },
        {
          field: "ステータス",
          value: this.displayJobState(importHistory.state),
        },
        {
          field: "開始時刻",
          value: importHistory.instructed_at
            ? moment(importHistory.instructed_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        },
        {
          field: "終了時刻",
          value: importHistory.finish_at
            ? moment(importHistory.finish_at).format("YYYY-MM-DD HH:mm:ss")
            : "-",
        },
        {
          field: "完了までの時間",
          value: this.calcDuration(
            importHistory.instructed_at,
            importHistory.finish_at
          ),
        },
        {
          field: "処理済みのレコード数",
          value:
            detail && detail.hasOwnProperty("total_count")
              ? detail["total_count"]
              : "-",
        },
        {
          field: "更新したレコード数",
          value:
            detail && detail.hasOwnProperty("update_count")
              ? detail["update_count"]
              : "-",
        },
        {
          field: "詳細",
          value: importHistory.message ? importHistory.message : "-",
        },
        {
          field: "同期ログ",
          value: importHistory.log_name,
          link: importHistory.log_path,
        },
      ];

      return table.map((item, i) => this.renderRow(item, i));
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Wrapper className={classes.root}>
        <Header
          title="Salesforce連携設定"
          secondaryTitle="同期履歴"
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() =>
            this.props.goTo("/setting/integrations/salesforce")
          }
        />
        <div className={classes.content}>
          <div className={classes.body}>
            <div className={classes.overview}>
              <div
                className={classes.progressbar}
                style={{ justifyContent: "flex-start" }}
              >
                <Button
                  className={classes.returnBtn}
                  onClick={() =>
                    this.props.goTo("/setting/integrations/salesforce")
                  }
                >
                  <ArrowLeft
                    color="#71737B"
                    width={14}
                    height={14}
                    style={{ marginRight: "6px" }}
                  />
                  <span>戻る</span>
                </Button>
              </div>
              <div className={classes.heading}>
                <Typography variant="title" className={classes.title}>
                  Salesforce同期履歴
                </Typography>
              </div>
              {(() => {
                if (
                  this.props.isLoadingImportHistory ||
                  this.props.importHistory === null
                ) {
                  return (
                    <div className={classes.box}>
                      <Loader type="color" />
                    </div>
                  );
                } else {
                  return (
                    <div className={classes.box} style={{ minHeight: "unset" }}>
                      <div className={classes.section}>
                        <Typography
                          variant="body2"
                          className={classes.sectionType}
                        >
                          Salesforceインポート履歴の詳細
                        </Typography>
                        <Typography
                          variant="display3"
                          className={classes.sectionTitle}
                        >
                          JOB ID: {this.props.match.params.id}
                        </Typography>
                        <Typography
                          variant="subheading"
                          className={classes.desc}
                        >
                          Salesforce一括データ読み込みジョブの詳細を参照します。
                        </Typography>
                      </div>
                      <Table className={classes.table}>
                        <TableBody>{this.renderRows()}</TableBody>
                      </Table>
                    </div>
                  );
                }
              })()}
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

SalesforceImportHistoryDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  isLoadingImportHistory: PropTypes.bool,
  importHistory: PropTypes.object,
  getSalesforceImportHistoriesById: PropTypes.func.isRequired,
  match: PropTypes.object,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
};

export default withStyles(styles)(SalesforceImportHistoryDetail);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceImportHistory/SalesforceImportHistoryDetail.jsx